module.exports = __webpack_public_path__ + "img/illustration_card_payment.9ea9d96b.svg";